import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const SideText = ({ content }) => {

    return (
        <div className={styles.slideText}>
            <div
                className={styles.slideTextTh}
                style={{ backgroundImage: `url(${content.mouldeSmallImage})` }}
            >{content.title}</div>
            <div className={styles.slideTextList}>
                {content.sideTextData.slice(0, 3).map((item, index) => {
                    return (
                        <a
                            href={item.url}
                            key={index}
                            target="_blank"
                            className={`${styles.slideTextItem}`}>
                            <div className={`${styles.slideTextTitle} ${index === 2 ? styles.slideTextTitleOne : styles.slideTextTitleTwo}`}>
                                {item.title}
                            </div>
                            <div className={styles.slideTextBref}>
                                {item.summary.length > 28 ? 
                                    `${item.summary.slice(0, 28)} ......` :
                                    item.summary
                                }
                                {item.summary && <span className={styles.slideTextMore}>&gt;&gt;详细</span>}
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

SideText.propTypes = {
    content: PropTypes.object
};

export default errorBoundary(SideText);
